import { DefaultTheme } from 'styled-components/macro';
import { TextProps } from '../text';
import { AvatarSize } from './avatar.types';

type AvatarSettingsReturn = {
  iconSize: number;
  textMode: TextProps['variant'];
  size: number;
  radius?: string;
  groupAvatarBorder?: number;
  groupOverlay?: string;
};

export const getAvatarSettings = (
  theme?: DefaultTheme
): Record<AvatarSize, AvatarSettingsReturn> => ({
  xl: {
    size: 96,
    iconSize: 48,
    textMode: 'heading-1',
    ...(theme
      ? {
          radius: theme.radiuses.base,
          groupAvatarBorder: 4,
          groupOverlay: theme.spacings.l,
        }
      : undefined),
  },
  l: {
    size: 44,
    iconSize: 24,
    textMode: 'button-16',
    ...(theme
      ? {
          radius: theme.radiuses.xs,
          groupAvatarBorder: 2,
          groupOverlay: theme.spacings.base,
        }
      : undefined),
  },
  m: {
    size: 32,
    iconSize: 16,
    textMode: 'button-14',
    ...(theme
      ? {
          radius: theme.radiuses.xxs,
          groupAvatarBorder: 2,
          groupOverlay: theme.spacings.s,
        }
      : undefined),
  },
  s: {
    size: 24,
    iconSize: 12,
    textMode: 'button-12',
    ...(theme
      ? {
          radius: theme.radiuses.xxxs,
          groupAvatarBorder: 2,
          groupOverlay: theme.spacings.xs,
        }
      : undefined),
  },
});
